import axios from "axios";
// /* 设置默认地址 */
axios.defaults.baseURL = 'http://ssck.hrclass.com.cn:8083'
// axios.defaults.baseURL = 'http://web.seo.hrclass.com.cn:8083'



export default axios;